// DonutFileStatusChart.jsx
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

// Center text plugin
const centerTextPlugin = {
  id: "centerText",
  beforeDraw: (chart) => {
    const { ctx, chartArea } = chart;
    if (!chartArea) return;

    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);

    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = "#607683";
    ctx.font = "700 9px 'Segoe UI', sans-serif";
    ctx.fillText("TASK STATUS", centerX, centerY - 18);
    ctx.fillStyle = "#173b4a";
    ctx.font = "700 27px 'Segoe UI', sans-serif";
    ctx.fillText(total, centerX, centerY + 5);
    ctx.fillStyle = "#607683";
    ctx.font = "600 9px 'Segoe UI', sans-serif";
    ctx.fillText("TOTAL TASKS", centerX, centerY + 25);
    ctx.restore();
  },
};

const DonutFileStatusChart = ({
  completed,
  almostExpired,
  review,
  notStarted,
}) => {
  const data = {
    labels: ["Completed", "Almost Expired", "Ready for Review", "Not Started"],
    datasets: [
      {
        data: [completed, almostExpired, review, notStarted],
        backgroundColor: ["#238a5a", "#3b82a0", "#d9a01b", "#c93d4b"],
        borderColor: "#ffffff",
        borderWidth: 3,
        borderRadius: 4,
        hoverOffset: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    cutout: "76%",
    layout: { padding: 7 },
    animation: { duration: 450 },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
  );
};

export default DonutFileStatusChart;
